export default {
  resolve: iconName => ({
    id: `v2-icon-${iconName}`,
    className: ''
  })
};